<template>
	<div class="lost-found-header" v-bind:class="modeClass">
		<figure class="lost-found-avatar">
			<img v-if="avatar" class="avatar-image" v-bind:src="avatar" v-bind:alt="author"
			  width="30" height="30" />
			<figcaption class="author">{{author}}</figcaption>
		</figure>
		<div class="lost-found-dates" v-bind:class="modeClass">
			<detail-description icon="date" label="Fecha" v-bind:description="date"
			/>
			<detail-description icon="time-standard" label="Hora" v-bind:description="time"
			/>
		</div>
	</div>
</template>

<script>

import DetailDescription from './DetailDescription';

function modeClass() {
	return this.mode === 'room' ? 'room' : '';
}

export default {
	components: {
		DetailDescription,
	},
	computed: {
		modeClass,
	},
	name: 'lost-found-header',
	props: {
		author: {
			type: String,
			required: 'Giovanni Alvarado',
		},
		avatar: {
			type: String,
		},
		date: {
			type: String,
			required: '24/03/2017',
		},
		time: {
			type: String,
			required: '02:14:02 p.m.',
		},
		mode: {
			type: String,
			default: 'author',
		},
	},
};
</script>

<style lang="scss" scoped>
.lost-found-header {
	align-items: center;
	display: flex;

	&.room {
		align-items: flex-start;
		flex-direction: column;
	}

	.lost-found-avatar {
		display: inherit;

		.avatar-image {
			border-radius: 50%;
			vertical-align: middle;
		}

		.author {
			align-self: center;
			color: map-get($colors, default-dark);
			font-family: map-get($fonts, medium);
			font-size: 14px;
			font-weight: 500;
			margin-left: 6px;
		}
	}

	.lost-found-dates {
		margin-left: auto;

		&.room {
			margin: 0 auto 0 0;
		}
	}
}
</style>




// WEBPACK FOOTER //
// LostFoundHeader.vue?7eaf972c